import { HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { catchError, map, Observable, of } from 'rxjs'
import { ApplicationInsightsService } from '../services/application-insights/application-insights.service'
import { FeaturesService } from '../services/features/features.service'

const DENIED_REDIRECT = '/dashboard'

@Injectable({ providedIn: 'root' })
export class FeatureGuard {
  constructor(
    private featuresService: FeaturesService,
    private router: Router,
    private appInsights: ApplicationInsightsService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const featureName = route.data['feature'] as string | undefined

    if (!featureName) {
      this.appInsights.logEvent('FeatureGuard: route.data.feature is missing')
      this.router.navigate([DENIED_REDIRECT])
      return of(false)
    }

    return this.featuresService.GetFeatures().pipe(
      map((features) => {
        const enabled =
          features?.find((f) => f.name === featureName)?.enabled === true
        if (!enabled) {
          this.router.navigate([DENIED_REDIRECT])
          return false
        }
        return true
      }),
      catchError((err) => {
        // 401 means the session expired — let GlobalHttpInterceptorService redirect to /login
        if (err instanceof HttpErrorResponse && err.status === 401) {
          return of(false)
        }
        this.router.navigate([DENIED_REDIRECT])
        return of(false)
      }),
    )
  }
}
